import { useAppContext } from "../AppContextDef";
import useAuthFetch from "./useAuthFetch";

export const logType = {
  ERROR: "ERROR",
  NAVIGATION: "NAVIGATION",
  ACTION: "ACTION",
  START: "START",
  END: "END",
};


export const useJourney = () => {
  const customFetch = useAuthFetch();
  const {
    deviceData,
    allDetails,
    journeyData,
    applicationNo,
    endApiCalledRef
  } = useAppContext();

  const logJourney = async ({ type, message }) => {
    const url = `${process.env.REACT_APP_API_URL}/v1/log/create`;
    const method = "POST";
    const headers = {
      authorization: allDetails?.authToken,
      "Content-Type": "application/json",
    };
    const bodyContent = {
      applicationNo: applicationNo,
      journeyId: journeyData?.journeyId,
      logType: type,
      logMessage: message,
    };
    try {
      return await customFetch(url, method, headers, bodyContent);
    } catch (error) {
      console.error("Error logging journey:", error);
    }
  };

  const endJourney = async ({ journeyStatus, disagreeReason, customerImage }) => {
    try {
      endApiCalledRef.current = true

      const url = `${process.env.REACT_APP_API_URL}/v1/journey/end`;
      const method = "POST";
      const headers = {
        authorization: allDetails?.authToken,
        "Content-Type": "application/json",
      };
      const bodyContent = {
        journeyId: journeyData?.journeyId,
        journeyStatus,
        disagreeReason,
        customerImage,
        lat: deviceData?.latitude,
        lng: deviceData?.longitude,
        deviceDetails: {
          deviceName: deviceData?.deviceName,
          browserName: deviceData?.browserName,
          network: deviceData?.network,
        },
      };
      const { status } = await customFetch(url, method, headers, bodyContent);
      return status
    } catch (error) {
      console.error("Error ending journey:", error);
      return null;
    }
  };

  const updateJourney = async ({ screenshots, journeyQna, customerImage }) => {
    const url = `${process.env.REACT_APP_API_URL}/v1/journey/update`;
    const method = "POST";
    const headers = {
      authorization: allDetails?.authToken,
      "Content-Type": "application/json",
    };
    const bodyContent = {
      journeyId: journeyData?.journeyId,
      lat: deviceData?.latitude,
      lng: deviceData?.longitude,
      deviceDetails: {
        deviceName: deviceData?.deviceName,
        browserName: deviceData?.browserName,
        network: deviceData?.network,
      },
      journeyScreenshots: screenshots,
      journeyQna: journeyQna,
      customerImage,
    };
    
    try {
      return await customFetch(url, method, headers, bodyContent);
    } catch (error) {
      console.error("Error updating journey:", error);
    }
  };

  return { logJourney, endJourney, updateJourney };
};

export const fontMap = {
  "hi-IN": "Noto Sans Devanagari",
  "gu-IN": "Noto Sans Gujarati",
  "mr-IN": "Noto Sans Devanagari",
  "pa-IN": "Noto Sans Gurmukhi",
  "bn-IN": "Noto Sans Bengali",
  "kn-IN": "Noto Sans Kannada",
  "ta-IN": "Noto Sans Tamil",
  "te-IN": "Noto Sans Telugu",
  "ml-IN": "Noto Sans Malayalam",
  "od-IN": "Noto Sans Oriya",
};
